import Topic from '@/models/topic';
import restify from '@/extensions/restify';

export default restify(Topic, '/admin/topics');
